import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActionArea from '@mui/material/CardActionArea';
import Typography from '@mui/material/Typography';
import {PulseLoader } from "react-spinners";
import PageTitle from "../../../layouts/PageTitle";
import React, { useState, Fragment, useEffect } from "react";
import {
   GetSite,
   GetShopId,
   CreateEmptySite
} from './Requests';
import './MiniSite.css'
import General from './General';
import Theme from './Theme';
import BusinessInfo from './BussinessInfo';
import SiteSections from './SiteSections';
import Socials from './Socials';

const MiniSite = () => {
   const [site, setSite] = useState("setup")
   const [shopId, setShopId] = useState()
   const [isLoading, setIsLoading] = useState(true)
   const [tab, setTab] = useState("General")
   const [isLive, setIsLive] = useState(false);
   const toggleLiveStatus = () => {
      setIsLive(!isLive);
   };

   useEffect(() => {
      GetSiteWrapper()
   }, []);
   
   function GetSiteWrapper()
   {
      GetSite().then((res) => {
         console.log(res.data)
         setSite(res.data)
      }).catch((error) => {

      }).finally(()=> {
         GetShopDetailsWrapper()
      })
   }

   function GetShopDetailsWrapper()
   {
      GetShopId().then((res) => {
         setShopId(res.data)
      }).catch((error) => {

      }).finally(()=> {
         setIsLoading(false)
      })
   }

   function CreateEmptySiteWrapper()
   {
      CreateEmptySite().then((res) => {
         setSite("setup")
      }).catch((error) => {

      }).finally(()=> {
         GetSiteWrapper()
      })
   }

     const renderTabs = () => {
       switch (tab.toLowerCase()) {
         case "general":
           return (
             <div>
               {/* <h1>General</h1> */}
               <General shopId={shopId} site={site}/>
           </div>
           );
         case "details":
           return (
             <main>
               <h1>Business Info</h1>
               <BusinessInfo site={site} getSite={GetSiteWrapper}/>
           </main>
           );
         case "sections":
           return (
            <div>
               <main>
                  <h1>Site Sections</h1>
               </main>
               <SiteSections site={site} getSite={GetSiteWrapper}/>
            </div>
           );
         case "theme":
           return (
             <main>
               <h1>Theme</h1>
               <p>Add a personal touch to your site by choosing a theme and using your logo and header image</p>
               <Theme shopId={shopId} site={site} getSite={GetSiteWrapper}/>
             </main>
           );
         case "socials":
           return (
             <main>
               <h1>Social Media</h1>
               <p>Let you customer's reach you via social media by adding your socials media links below</p>
               <Socials site={site} getSite={GetSiteWrapper}/>
             </main>
           );
         default:
           return null;
       }
     };
     
   return(
   <div>
      {/* <PageTitle activeMenu="Site" motherMenu="Barber Shop" /> */}
      {isLoading
      ?
      <div className="card">
         <div className="card-body ">
            <div style={{display:'flex', justifyContent:'center', alignItems: 'center'}}>
               <div className="test">        
                  <PulseLoader 
                     color={'#333'}
                     loading={isLoading}
                     size={25}
                     aria-label="Loading Spinner"
                     data-testid="loader"
                  />
               </div>
            </div>
         </div>
      </div>
      :
      <></>
      }
      <div>
         {((!isLoading) && (site === ""))
         ?
         <div className="card">
            <div className="card-body ">
               <div style={{display:'flex', justifyContent:'center', alignItems: 'center', textAlign:"center"}}>
                  <p>If you have a website and would like to send your customers to your appointment booking portal, you can use the link below</p>
               </div>            
               <div className="mb-5" style={{display:'flex', justifyContent:'center', alignItems: 'center', textAlign:"center"}}>
                  <a target="_blank" style={{textDecoration: "underline"}} href={"make-a-booking?id=" + shopId}>www.barber.shanil.com/make-a-booking?id={shopId}</a>
               </div>
               <div style={{display:'flex', justifyContent:'center', alignItems: 'center', textAlign:"center"}}>
                  <p>Alternitively, if you want to connect with your customers through a easy customisable mini site, click setup mini site. This will give yours customers somewhere to view the services you provide and how to contact you, along with your booking portal.</p>
               </div>
               <div style={{display:'flex', justifyContent:'center', alignItems: 'center'}}>
                  <button onClick={() => {CreateEmptySiteWrapper()}} className='connect-button mb-3'>
                     Setup Mini Site
                  </button>
               </div>
            </div>
         </div>
         :
         !isLoading ?
         <div className='container' style={{marginTop:0, paddingTop:0}}>
            <div className="sub-nav" style={{marginTop:0}}>
               {['General', 'Theme', 'Details', 'Sections', 'Socials'].map(tabOption => (
                  <a
                     key={tabOption}
                     href="#"
                     className={`sub-tab ${tab === tabOption ? "active" : ""}`}
                     onClick={() => setTab(tabOption)}
                  >
                  {tabOption}
                  </a>
               ))}
            </div>
         {renderTabs()}
         </div>
         :
         <></>
         }
      </div>
   </div>
   );
};

export default MiniSite;